import anime from 'animejs'

import { $1 } from "../utilities/selector"
import {stringifyQuery} from "../utilities/parse-query"

import LoadManager, { QUEUE } from "./load-manager"

import {Map} from './html/map';

import memberList from '../templates/member-list'
import spinner from '../templates/spinner'

const API_URL = "http://pra-rmi-members.01.visarcwebdev.co.uk/membersearch/";

export class MemberSearch {
  static getUrl(query = {}) {
    return `${API_URL}?${stringifyQuery(query)}`;
  }

  static createMarker({
    location, 
    name, 
    telephone, 
    address1, 
    address2, 
    address3
  }) {
    var address = [address1, address2, address3]
      .filter(x => !!x)
      .join(", ");

    return {
      position: location,
      title: name,
      address,
      content:
        `<div class="InfoWindow">
          <h4 class="u-mb0">${name}</h4>
          <address>${address}</address>
          <a href="tel:${telephone}">${telephone}</a>
        </div>`
    };
  }

  constructor() {
    // Get Elements
    this.elements = {
      form: $1("[data-js=membersearch-form]"),
      map: $1("[data-js=membersearch-map]"),
      results: $1("[data-js=membersearch-results]")
    }

    // Check elements
    if (!this.elements.form || !this.elements.map || !this.elements.results)
      return;
      
    if ( ! this.elements.form )
      throw new Error("Member Search: Form was not found")

    if ( ! this.elements.map )
      throw new Error("Member Search: Map was not found")

    if ( ! this.elements.results )
      throw new Error("Member Search: Results list was not found")

    // Bind functions
    this.submit = this.submit.bind(this);
    this.ready = this.ready.bind(this);

    // State
    this.dirty = false;
    this.waiting = false;

    LoadManager.queue(this.ready, QUEUE.RESOURCES);
  }

  ready() {
    // Setup map
    this.map = new Map(this.elements.map);

    // Listen for searches
    this.elements.form.addEventListener("submit", this.submit);
  }

  submit(e) {
    e.preventDefault();
    if ( this.waiting )
      return;

    this.search({q: e.currentTarget.elements[0].value});
    this.revealMap();
  }

  async search(query = {}) {
    let loading = this.renderLoad();
    try {
      let response = await fetch(MemberSearch.getUrl(query));
      let json = await response.json(); 
      await loading;
      if ( json.length ) {
        this.renderList(json);
        this.renderMarkers(json);
      } else {
        this.renderEmpty(query.q);
      }
      this.elements.form.elements[1].innerHTML = "Find a member";
      this.waiting = false;
    } catch (error) {
      console.log(error);
    }
  }

  revealMap() {
    if ( this.dirty )
      return;
    this.dirty = true;
    anim.moveForm(this.elements.form);
  }

  async renderLoad() {
    this.waiting = true;
    if ( this.map.ready )
      this.map.clearMarkers();

    this.elements.form.elements[1].innerHTML = spinner(16);

    this.elements.results.innerHTML = 
      `<p class="u-ta-center u-pt2 u-pb2">${spinner(80)}</p>`;
      
    return anim.showResults(this.elements.results).finished;
  }

  renderList(model) {
    this.elements.results.innerHTML = memberList(model);
    anim.showResults(this.elements.results);
  }

  renderMarkers(items) {
    if ( this.map.ready )
      this.map.setMarkers(items.map(MemberSearch.createMarker));
  }

  renderEmpty(q) {
    this.elements.results.innerHTML = 
      `<div class="u-ta-center u-pt2 u-pb2">
        <h3>Oh no!</h3>
        <p>It looks like we don't have any members in "${q}"</p>
      </div>`;
  }
}

const anim = {
  moveForm(el) {
    return anime({
      targets: el,
      translateY: Math.round(el.parentNode.offsetHeight / 2) + "px",
      easing: 'easeOutSine',
      duration: 350
    })
  },
  showResults(el) {
    return anime({
      targets: el,
      height: el => el.firstChild 
        ? el.firstChild.offsetHeight + "px"
        : 0,
      easing: 'easeOutSine',
      duration: 250
    })
  }
};

export default LoadManager.queue(() => {
  new MemberSearch;
}, QUEUE.DOM)


// WEBPACK FOOTER //
// ./scripts/components/member-search.js